/* Zirconium Bolt Action drop PDP — countdown + gallery label swap.
   Drop instant comes from the section's "Countdown deadline" setting via
   data-drop on each [data-buy-block]; the literal below is only a fallback.
   Sold-out state renders no ATC/countdown nodes — blocks without them are skipped. */
(function () {
  'use strict';

  var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-buy-block]'));
  if (blocks.length) {
    var attr = blocks[0].getAttribute('data-drop');
    var DROP = Date.parse(attr || '') || Date.parse('2026-07-31T17:00:00Z');
    var tick = function () {
      var diff = DROP - Date.now();
      var live = diff <= 0;
      blocks.forEach(function (b) {
        var atc = b.querySelector('[data-atc]');
        var cd = b.querySelector('[data-countdown]');
        if (!atc || !cd) return; // sold-out render has neither
        if (live) { atc.hidden = false; cd.hidden = true; return; }
        atc.hidden = true; cd.hidden = false;
        var s = Math.floor(diff / 1000);
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        var pad = function (n) { n = String(n); return n.length < 2 ? '0' + n : n; };
        cd.querySelector('[data-d]').textContent = pad(d);
        cd.querySelector('[data-h]').textContent = pad(h);
        cd.querySelector('[data-m]').textContent = pad(m);
        cd.querySelector('[data-s]').textContent = pad(s);
      });
      if (!live) setTimeout(tick, 1000);
    };
    tick();
  }

  var label = document.querySelector('[data-gallery-label]');
  var mainImg = document.querySelector('[data-gallery-img]');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
  if ((label || mainImg) && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var img = t.getAttribute('data-image');
        if (mainImg && img) {
          mainImg.src = img;
          mainImg.alt = t.getAttribute('data-shot') || '';
        } else if (label) {
          label.textContent = t.getAttribute('data-shot');
        }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }
})();
